/** если имя слишком длинное, происходит его обрезка */
export var getFileName = function getFileName(name) {
  var arrayFromName = name.split('.');
  var fileExtension = arrayFromName[arrayFromName.length - 1];
  var fileName = name.substring(0, name.length - fileExtension.length - 1);
  var result = '';
  if (fileName.length <= 20) {
    result = "".concat(fileName, ".").concat(fileExtension);
  } else {
    var firstName = fileName.substring(0, 18);
    var lastName = fileName.substring(fileName.length - 2);
    result = "".concat(firstName, "...").concat(lastName, ".").concat(fileExtension);
  }
  return result;
};